import miniToastr from 'mini-toastr'

var selected_device;
var devices = [];

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

export function setup() {

  BrowserPrint.getDefaultDevice("printer", function (device) {

    selected_device = device;
    devices.push(device);

    var html_select = document.getElementById("selected_device");
    var option = document.createElement("option");
    option.text = device.name;
    html_select.add(option);

    BrowserPrint.getLocalDevices(function (device_list) {
      for (var i = 0; i < device_list.length; i++) {

        var device = device_list[i];
        if (!selected_device || device.uid != selected_device.uid) {
          devices.push(device);
          var option = document.createElement("option");
          option.text = device.name;
          option.value = device.uid;
          html_select.add(option);
        }
      }

    }, function () {

      miniToastr.info("Error al obtener los dispositivos locales.", "");

    }, "printer");

  }, function (error) {

    miniToastr.info("Error al detectar la impresora.", "");

  })


}


export function Printer(dataToWrite, typeLabel, numbrePrint) {

  //Etiqueta 4x6 pulgadas

  if (typeLabel == 1) {

    selected_device.send("^XA\
        ^FX Top section with company logo, name and address.\
        ^CF0,60\
        ^FO50,135^FD" + eliminarDiacriticos(dataToWrite.product_name) + "^FS\
        ^FO50,195^FD" + eliminarDiacriticos(dataToWrite.variety_name) + "^FS\
        ^CF0,40\
        ^FO50,250^GB700,1,3^FS\
        ^FX Second section with recipient address and permit information.\
        ^CFA,30\
        ^FO50,265^FDLote: " + eliminarDiacriticos(dataToWrite.lot_number) + "^FS\
        ^FO50,305^FDProductor: " + eliminarDiacriticos(dataToWrite.origin_name) + "(" + dataToWrite.origin_code + ")^FS\
        ^FO50,340^FDGuia de despacho: " + dataToWrite.waybill_number + "^FS\
        ^FO50,380^FDFecha de recepcion: " + dataToWrite.waybill_date + "^FS\
        ^FO50,420^FD" + eliminarDiacriticos(dataToWrite.client_customer_name) + "^FS\
        ^FO50,460^FDTipo producto: " + eliminarDiacriticos(dataToWrite.product_type_name) + "^FS\
        ^CFA,15\
        ^FO50,500^GB700,1,3^FS\
        ^FX Fourth section (the two boxes on the bottom).\
        ^FO50,800^GB700,150,3^FS\
        ^FO400,800^GB1,150,3^FS\
        ^CF0,40\
        ^FO50,670^FD" + eliminarDiacriticos(dataToWrite.container_name) + ".^FS\
        ^FO50,750^FDUnidades:" + dataToWrite.quantity + "^FS\
        ^FO500,900^BY4,2.0,65^BQ,2,7^FDQA,"+dataToWrite.pallet_number+"^FS\
        ^CF0,40\
        ^FO80,815^FDKG BRUTOS^FS\
        ^FO425,815^FDKG NETOS^FS\
        ^CF0,80\
        ^FO425,860^FD" + dataToWrite.net_kilograms + "^FS\
        ^FO80,860^FD" + dataToWrite.gross_kilograms + "^FS\
        ^CF0,130\
        ^FO50,520^FD" + eliminarDiacriticos(dataToWrite.condition) + "^FS\
        ^CF0,130\
        ^FO50,30^FD" + dataToWrite.pallet_number + "^FS\
        ^PQ" + numbrePrint + "\
        ^XZ", undefined, errorCallback);

  }


  //Etiqueta 4x3 pulgadas
  if (typeLabel == 2) {

    var waybill_date = formato(dataToWrite.waybill_date);

    selected_device.send("^XA\
    ^FX Top section with company logo, name and address.\
    ^CF0,60\
    ^FO50,50^FDPALLET: " + dataToWrite.pallet_number + "^FS\
    ^CF0,40\
    ^FO50,100^FD" + eliminarDiacriticos(dataToWrite.variety_name) + " - " + eliminarDiacriticos(dataToWrite.product_name) + "^FS\
    ^FO50,144^FD" + eliminarDiacriticos(dataToWrite.origin_name) + " (" + dataToWrite.origin_code + ")^FS\
    ^FO50,190^GB700,1,3^FS\
    ^FX Second section with recipient address and permit information QR.\
    ^FO650,50^BY4,2.0,20^BQ,2,5^FDQA,"+dataToWrite.pallet_number+"^FS\
    ^CFA,30\
    ^FO50,210^FDLOTE: " + dataToWrite.lot_number + " | " + eliminarDiacriticos(dataToWrite.condition) + "^FS\
    ^CFA,22\
    ^FO50,270^FDGUIA:" + dataToWrite.waybill_number + "^FS\
    ^FO50,310^FDKB:" + dataToWrite.gross_kilograms + "^FS\
    ^FO50,350^FDKN:" + dataToWrite.net_kilograms + "^FS\
    ^FO50,390^FDFECHA:" + waybill_date + "^FS\
    ^FO50,430^FDUNIDADES:" + dataToWrite.quantity + "^FS\
    ^FO380,270^FDEXP:" + eliminarDiacriticos(dataToWrite.client_customer_name) + "^FS\
    ^FO380,310^FDTIPO PRODUCTO: " + eliminarDiacriticos(dataToWrite.product_type_name) + "^FS\
    ^FO380,350^FDVARIEDAD:" + eliminarDiacriticos(dataToWrite.variety_name) + "^FS\
    ^FO380,390^FDSPECS:" + eliminarDiacriticos(dataToWrite.string_specs) + "^FS\
    ^FO380,430^FDRECIPIENTE:" + eliminarDiacriticos(dataToWrite.container_name) + "^FS\
    ^PQ" + numbrePrint + "\
    ^CFA,15\
    ^XZ", successCallback, errorCallback);

  }

  //Bodega
  if (typeLabel == 3) {
    var waybill_date = formato(dataToWrite.waybill_date);

    selected_device.send("^XA\
          ^FX Top section with company logo, name and address.\
          ^CF0,80\
          ^FO650,80^FD" + dataToWrite.supply_family + "^FS\
          ^CF0,60\
          ^FO30,50^FD"+eliminarDiacriticos(dataToWrite.supply_name)+"^FS\
          ^FO30,230^FDCantidad: "+dataToWrite.quantity+"^FS\
          ^CF0,30\
          ^FO30,110^FDExp: " + eliminarDiacriticos(dataToWrite.client_customer_name) + "^FS\
          ^FO30,145^FDProv: " + eliminarDiacriticos(dataToWrite.company_name) + "^FS\
          ^FO30,175^FDGD: " + dataToWrite.waybill_number + " - " + waybill_date + "^FS\
          ^FO50,210^GB700,1,3^FS\
          ^FX Third section with barcode.\
          ^BY3,2,150\
          ^FO30,290^BC^FD" + dataToWrite.supply_lot + "^FS\
          ^PQ" + numbrePrint + "\
          ^XZ", successCallback, errorCallback);

  }

  if (typeLabel == 4) {
    var waybill_date = formato(dataToWrite.waybill_date);

    selected_device.send("^XA\
      ^CF0,250\
      ^FO550,100^A0R^FD" + dataToWrite.pallet_number + "^FS\
      ^CF0,70\
      ^FO580,20^A0R^FDProductor:\
      ^CF0,120\
      ^FO460,20^A0R^FD" + eliminarDiacriticos(dataToWrite.origin_short_name) + "(" + dataToWrite.origin_code + ")^FS\
      ^FO330,20^A0R^FD" + eliminarDiacriticos(dataToWrite.product_name) + " - " + eliminarDiacriticos(dataToWrite.variety_name) + "^FS\
      ^CF0,60\
      ^FO260,20^A0R^FDFecha de recepcion: " + waybill_date + "^FS\
      ^FO180,20^A0R^FDLote: " + eliminarDiacriticos(dataToWrite.lot_number) + "^FS\
      ^CF0,50\
      ^CFA,15\
      ^FX Fourth section (the one boxes on the bottom).\
      ^FO20,20^GB150,700,3^FS\
      ^CF0,40\
      ^FO110,50^A0R^FDKG NETOS^FS\
      ^CF0,90\
      ^FO50,280^A0R^FD" + dataToWrite.net_kilograms + "^FS\
      ^FO50,750^A0R^FDG:" + dataToWrite.waybill_number + "^FS\
      ^PQ" + numbrePrint + "\
      ^XZ", successCallback, errorCallback);
  }




   //Etiqueta 10x15 V(UN)
   if (typeLabel == 5) {

    selected_device.send("^XA\
        ^FX Top section with company logo, name and address.\
        ^CF0,60\
        ^FO50,135^FD" + eliminarDiacriticos(dataToWrite.product_name) + "^FS\
        ^FO50,195^FD" + eliminarDiacriticos(dataToWrite.variety_name) + "^FS\
        ^CF0,40\
        ^FO50,250^GB700,1,3^FS\
        ^FX Second section with recipient address and permit information.\
        ^CFA,30\
        ^FO50,265^FDLote: " + eliminarDiacriticos(dataToWrite.lot_number) + "^FS\
        ^FO50,305^FDProductor: " + eliminarDiacriticos(dataToWrite.origin_name) + "(" + dataToWrite.origin_code + ")^FS\
        ^FO50,340^FDGuia de despacho: " + dataToWrite.waybill_number + "^FS\
        ^FO50,380^FDFecha de recepcion: " + dataToWrite.waybill_date + "^FS\
        ^FO50,420^FD" + eliminarDiacriticos(dataToWrite.client_customer_name) + "^FS\
        ^FO50,460^FDTipo producto: " + eliminarDiacriticos(dataToWrite.product_type_name) + "^FS\
        ^CFA,15\
        ^FO50,500^GB700,1,3^FS\
        ^CF0,40\
        ^FO50,670^FD" + eliminarDiacriticos(dataToWrite.container_name) + ".^FS\
        ^FO50,750^FDENVASES:" + dataToWrite.quantity + "^FS\
        ^FO500,900^BY4,2.0,65^BQ,2,7^FDQA,"+dataToWrite.pallet_number+"^FS\
        ^CF0,40\
        ^FO50,815^FDUN: " + dataToWrite.net_kilograms + "^FS\
        ^CF0,130\
        ^FO50,520^FD" + eliminarDiacriticos(dataToWrite.condition) + "^FS\
        ^CF0,130\
        ^FO50,30^FD" + dataToWrite.pallet_number + "^FS\
        ^PQ" + numbrePrint + "\
        ^XZ", undefined, errorCallback);

  }

  //10x15 Landscape (P)
  if (typeLabel == 6) {

    selected_device.send("^XA\
    ^FO640,40^GB120,1100,3^FS\
    ^CF0,100\
    ^FO640,50^A0R^FD GUIA:" + dataToWrite.waybill_number + "^FS\
    ^CF0,120\
    ^FO500,20^A0R^FD FOLIO: "+dataToWrite.pallet_number+"^FS\
    ^CF0,80\
    ^FO420,20^A0R^FD ESPECIE:"+eliminarDiacriticos(dataToWrite.product_name) + "^FS\
    ^FO340,20^A0R^FD VARIEDAD:"+eliminarDiacriticos(dataToWrite.variety_name) + "^FS\
    ^FO260,20^A0R^FD FECHA RECEPCION:" + dataToWrite.waybill_date + "^FS\
    ^CF0,60\
    ^FO180,20^A0R^FD CSG:"+dataToWrite.origin_code+"-"+eliminarDiacriticos(dataToWrite.origin_province)+"-"+eliminarDiacriticos(dataToWrite.origin_township)+"^FS\
    ^FO100,20^A0R^FD PLANTAS X CAJON:" + dataToWrite.net_kilograms + "^FS\
    ^FO20,20^A0R^FD LOTE: " + eliminarDiacriticos(dataToWrite.lot_number) + "^FS\
    ^CF0,40\
    ^FO25,700^A0R^FD" + eliminarDiacriticos(dataToWrite.string_specs) + "^FS\
    ^PQ" + numbrePrint + "\
    ^XZ", undefined, errorCallback);

  }


  //Etiqueta 10x15 V(UN-C)
  if (typeLabel == 7) {

    selected_device.send("^XA\
        ^FX Top section with company logo, name and address.\
        ^CF0,60\
        ^FO50,135^FD" + eliminarDiacriticos(dataToWrite.product_name) + "^FS\
        ^FO50,195^FD" + eliminarDiacriticos(dataToWrite.variety_name) + "^FS\
        ^CF0,40\
        ^FO50,250^GB700,1,3^FS\
        ^FX Second section with recipient address and permit information.\
        ^CFA,30\
        ^FO50,265^FDLote: " + eliminarDiacriticos(dataToWrite.lot_number) + "^FS\
        ^FO50,305^FDProductor: " + eliminarDiacriticos(dataToWrite.origin_name) + "(" + dataToWrite.origin_code + ")^FS\
        ^FO50,340^FDGuia de despacho: " + dataToWrite.waybill_number + "^FS\
        ^FO50,380^FDFecha de recepcion: " + dataToWrite.waybill_date + "^FS\
        ^FO50,420^FD" + eliminarDiacriticos(dataToWrite.client_customer_name) + "^FS\
        ^FO50,460^FDTipo producto: " + eliminarDiacriticos(dataToWrite.product_type_name) + "^FS\
        ^CFA,15\
        ^FO50,500^GB700,1,3^FS\
        ^CF0,40\
        ^FO50,670^FD" + eliminarDiacriticos(dataToWrite.container_name) + ".^FS\
        ^FO50,750^FDENVASES:" + dataToWrite.quantity + "^FS\
        ^FO500,900^BY4,2.0,65^BQ,2,7^FDQA,"+dataToWrite.pallet_number+"^FS\
        ^CF0,40\
        ^FO50,815^FDUN: " + dataToWrite.net_kilograms + "^FS\
        ^FO50,875^FDCLASF: " + eliminarDiacriticos(dataToWrite.classification) + "^FS\
        ^CF0,130\
        ^FO50,520^FD" + eliminarDiacriticos(dataToWrite.condition) + "^FS\
        ^CF0,130\
        ^FO50,30^FD" + dataToWrite.pallet_number + "^FS\
        ^PQ" + numbrePrint + "\
        ^XZ", undefined, errorCallback);

  }



  //Etiqueta 4x3 pulgadas P(PLANT)
  /*
  if (typeLabel == 6) {

    selected_device.send("^XA\
    ^FX Top section with company logo, name and address.\
    ^CFA,30\
    ^FO340,20^GB440,95,3^FS\
    ^FO520,35^FDGUIA^FS\
    ^CF0,50\
    ^FO0,70^A0N,40,40^FB1110,1,0,C^FD" + dataToWrite.waybill_number + "^FS \
    ^FO50,200^GB700,1,3^FS\
    ^CF0,60\
    ^FO50,140^FDFOLIO:"+dataToWrite.pallet_number+"^FS\
    ^CFA,30\
    ^FO50,230^FDESPECIE:" + eliminarDiacriticos(dataToWrite.product_name) + "^FS\
    ^FO50,270^FD" + eliminarDiacriticos(dataToWrite.variety_name) + "^FS\
    ^FO50,310^FDFECHA^FS\
    ^FO50,340^FDRECEPCION^FS\
    ^FO240,320^FD" + dataToWrite.waybill_date + "^FS\
    ^CFA,30\
    ^FO50,380^FDCSG:" + eliminarDiacriticos(dataToWrite.origin_name) + "(" + dataToWrite.origin_code + ")^FS\
    ^CFA,30\
    ^FO340,430^GB440,160,3^FS\
    ^FO430,450^FDPLANTAS X CAJON^FS\
    ^CF0,50\
    ^FO0,490^A0N,50,50^FB1110,1,0,C^FD" + dataToWrite.net_kilograms + "^FS \
    ^CFA,30\
    ^FO0,550^A0N,25,25^FB1110,1,0,C^FD" + eliminarDiacriticos(dataToWrite.string_specs) + "^FS \
    ^PQ" + numbrePrint + "\
    ^XZ", undefined, errorCallback);

  }
  */


}

export function PrintPallet(dataToWrite, numbrePrint,typeLabel) {

  
   // Etiqueta Arandano
  if(typeLabel==1)
  {

    var detalles = "";

  var cordy1 = 440;
  var cordy2 = 470;
  var cordy3 = 500;
  var cordy4 = 540;

  var total_cantidad = 0;

    for (var i = 0; i < dataToWrite.contents.length; i++) {

      detalles += "^CF0,28\
      ^FO50," + cordy1 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].origin) +"^FS\
      ^FO50," + cordy2 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].plant) + " - LOT: " + (dataToWrite.contents[i].lot_number || "S/L") + "^FS\
      ^FO50," + cordy3 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].variety_name)
        + " - " + formato(dataToWrite.contents[i].creation_date)
        + " - " + eliminarDiacriticos2(dataToWrite.contents[i].string_specs) + "^FS\
      ^CF0,50\
      ^FO710," + cordy2 + "^FD" + dataToWrite.contents[i].quantity + "^FS\
      ^FO50," + cordy4 + "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 130;
      cordy2 = cordy2 + 130;
      cordy3 = cordy3 + 130;
      cordy4 = cordy4 + 130;
    }

      selected_device.send("^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
      ^FO50,20^FD" + dataToWrite.number + "^FS\
      ^FO585,187^BY4,2.0,65^BQ,2,4^FDQA,"+dataToWrite.number+"^FS\
			^CF0,60\
			^FO45,170^FD"+dataToWrite.client_customer+"^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,45\
			^FO50,255^FD" + eliminarDiacriticos(dataToWrite.contents[0].container.text) + "^FS\
			^FO50,295^FD" + eliminarDiacriticos(dataToWrite.contents[0].condition) + "^FS\
			^FO50,335^FD Solo para Exportacion ^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,35\
			^FO50,395^FDDETALLE^FS\
			^FO638,395^FDCANTIDAD^FS\
			^FX Seccion de detalle segun SAG\
			" + detalles + "\
			^CF0,100\
			^FO50," +cordy1+ "^FDTotal:" + total_cantidad+"^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" + numbrePrint + "\
			^XZ", successCallback, errorCallback);

  }


  // Etiqueta tipo 2 
  if(typeLabel==2)
  {

  var detalles = "";

  var cordy1 = 440;
  var cordy2 = 480;
  var cordy3 = 520;
  var cordy33 = 560;
  var cordy4 = 600;
  

  var total_cantidad = 0;
  

    for (var i = 0; i < dataToWrite.contents.length; i++) {

      detalles += "^CF0,40\
      ^FO50," + cordy1 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].origin) +"^FS\
      ^FO50," + cordy2 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].plant) + " ^FS\
      ^FO50," + cordy3 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].variety_name)
        + " - " + formato(dataToWrite.contents[i].creation_date)+ " ^FS\
      ^CF0,30\
      ^FO50," + cordy33 + "^FD" + eliminarDiacriticos2(dataToWrite.contents[i].string_specs) + " ^FS\
      ^CF0,50\
      ^FO710," + cordy2 + "^FD" + dataToWrite.contents[i].quantity + "^FS\
      ^FO50," + cordy4 + "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 170;
      cordy2 = cordy2 + 170;
      cordy3 = cordy3 + 170;
      cordy33 = cordy33 + 170;
      cordy4 = cordy4 + 170;
    }

      selected_device.send("^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
			^FO50,20^FD" + dataToWrite.number + "^FS\
			^FO585,187^BY4,2.0,60^BQ,2,5^FDQA,"+dataToWrite.number+"^FS\
			^CF0,45\
			^FO45,170^FD"+dataToWrite.client_customer+"^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,45\
			^FO50,255^FD" + eliminarDiacriticos(dataToWrite.contents[0].container.text) + "^FS\
			^FO50,295^FD" + eliminarDiacriticos(dataToWrite.contents[0].condition) + "^FS\
			^FO50,335^FD" + eliminarDiacriticos(dataToWrite.contents[0].product_type_name) + "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,40\
			^FO50,388^FDDETALLE^FS\
			^FO638,388^FDCANTIDAD^FS\
			^FX Seccion de detalle segun SAG\
      " + detalles + "\
      ^CF0,80\
      ^FO50," +cordy1+ "^FDTotal:" +total_cantidad+"^FS\
      ^FO50," +(parseInt(cordy1)+parseInt(70))+ "^FDTotal KG:" +dataToWrite.total_net_kilograms+"^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" + numbrePrint + "\
			^XZ", successCallback, errorCallback);

  }




  // Etiqueta tipo 3 
  if(typeLabel==3)
  {

  var detalles = "";

  var cordy1 = 440;
  var cordy2 = 480;
  var cordy3 = 520;
  var cordy33 = 560;
  var cordy4 = 600;
  

  var total_cantidad = 0;
  var total_kilogramos = '';

 
  if (dataToWrite.contents[0].container.value.bulk == true ){
    total_kilogramos = ' KG: ' + dataToWrite.total_net_kilograms;
  }


    for (var i = 0; i < dataToWrite.contents.length; i++) {

      detalles += "^CF0,40\
      ^FO50," + cordy1 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].origin) +"^FS\
      ^FO50," + cordy2 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].plant) + " ^FS\
      ^FO50," + cordy3 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].variety_name)
        + " - " + formato(dataToWrite.contents[i].creation_date)+ " ^FS\
      ^CF0,30\
      ^FO50," + cordy33 + "^FD" + eliminarDiacriticos2(dataToWrite.contents[i].string_specs) + " ^FS\
      ^CF0,50\
      ^FO710," + cordy2 + "^FD" + dataToWrite.contents[i].quantity + "^FS\
      ^FO50," + cordy4 + "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 170;
      cordy2 = cordy2 + 170;
      cordy3 = cordy3 + 170;
      cordy33 = cordy33 + 170;
      cordy4 = cordy4 + 170;
    }

      selected_device.send("^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
			^FO50,20^FD" + dataToWrite.number + "^FS\
			^FO585,187^BY4,2.0,65^BQ,2,4^FDQA,"+dataToWrite.number+"^FS\
			^CF0,45\
			^FO45,170^FD"+dataToWrite.client_customer+"^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,45\
			^FO50,255^FD" + eliminarDiacriticos(dataToWrite.contents[0].container.text) + "^FS\
			^FO50,295^FD" + eliminarDiacriticos(dataToWrite.contents[0].condition) + "^FS\
			^FO50,335^FD" + eliminarDiacriticos(dataToWrite.contents[0].product_type_name) + "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,40\
			^FO50,388^FDDETALLE^FS\
			^FO638,388^FDCANTIDAD^FS\
			^FX Seccion de detalle segun SAG\
      " + detalles + "\
      ^CF0,90\
			^FO50," +cordy1+ "^FD" +total_kilogramos+"^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" + numbrePrint + "\
			^XZ", successCallback, errorCallback);

  }



  // Etiqueta tipo 4
  if(typeLabel==4)
  {

  var detalles = "";

  var cordy1 = 445;
  var cordy2 = 520;
  var cordy3 = 580;
  var cordy33 = 655;
  var cordy4 = 730;
  

  var total_cantidad = 0;
  

    for (var i = 0; i < dataToWrite.contents.length; i++) {

      detalles += "^CF0,70\
      ^FO50," + cordy1 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].origin) +"^FS\
      ^CF0,50\
      ^FO50," + cordy2 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].plant) + " ^FS\
      ^CF0,70\
      ^FO50," + cordy3 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].variety_name)
        + " - " + formato(dataToWrite.contents[i].creation_date)+ " ^FS\
      ^CF0,70\
      ^FO50," + cordy33 + "^FD" + eliminarDiacriticos2(dataToWrite.contents[i].string_specs) + " ^FS\
      ^CF0,70\
      ^FO50," + cordy4 + "^GB750,1,1^FS";

      total_cantidad += parseInt(dataToWrite.contents[i].quantity);

      cordy1 = cordy1 + 305;
      cordy2 = cordy2 + 305;
      cordy3 = cordy3 + 305;
      cordy33 = cordy33 + 305;
      cordy4 = cordy4 + 305;
    }

      selected_device.send("^XA\
			^FX Top section with company logo, name and address.\
			^CF0,150\
			^FO50,20^FD" + dataToWrite.number + "^FS\
			^FO585,187^BY4,2.0,60^BQ,2,5^FDQA,"+dataToWrite.number+"^FS\
			^CF0,45\
			^FO45,170^FD"+dataToWrite.client_customer+"^FS\
			^CF0,40\
			^FO50,240^GB750,1,3^FS\
			^CF0,45\
			^FO50,255^FD" + eliminarDiacriticos(dataToWrite.contents[0].container.text) + "^FS\
			^FO50,295^FD" + eliminarDiacriticos(dataToWrite.contents[0].condition) + "^FS\
			^FO50,335^FD" + eliminarDiacriticos(dataToWrite.contents[0].product_type_name) + "^FS\
			^CF0,40\
			^FO50,380^GB750,1,3^FS\
			^FO50,420^GB750,1,3^FS\
			^CF0,35\
			^FO50,388^FDDETALLE^FS\
			^FX Seccion de detalle segun SAG\
      " + detalles + "\
      ^CF0,80\
      ^FO50," +cordy1+ "^FDTotal:" +total_cantidad+"^FS\
      ^FO50," +(parseInt(cordy1)+parseInt(80))+ "^FDTotal KG:" +dataToWrite.total_net_kilograms+"^FS\
			^FX  section with barcode.\
			^BY2,2,100\
			^FX Cantidada de etiquetas.\
			^PQ" + numbrePrint + "\
			^XZ", successCallback, errorCallback);

  }




   // Etiqueta tipo 5
   if(typeLabel==5)
   {
 
   var detalles = "";
 
   var cordy1 = 445;
   var cordy2 = 520;
   var cordy3 = 580;
   var cordy33 = 655;
   var cordy4 = 730;
   
 
   var total_cantidad = 0;
   
 
     for (var i = 0; i < dataToWrite.contents.length; i++) {
 
       detalles += "^CF0,70\
       ^FO50," + cordy1 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].origin) +"^FS\
       ^CF0,50\
       ^FO50," + cordy2 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].plant) + " ^FS\
       ^CF0,70\
       ^FO50," + cordy3 + "^FD" + eliminarDiacriticos(dataToWrite.contents[i].variety_name)
         + " - " + formato(dataToWrite.contents[i].creation_date)+ " ^FS\
       ^CF0,70\
       ^FO50," + cordy33 + "^FD" + eliminarDiacriticos2(dataToWrite.contents[i].string_specs) + " ^FS\
       ^CF0,70\
       ^FO50," + cordy4 + "^GB750,1,1^FS";
 
       total_cantidad += parseInt(dataToWrite.contents[i].quantity);
 
       cordy1 = cordy1 + 305;
       cordy2 = cordy2 + 305;
       cordy3 = cordy3 + 305;
       cordy33 = cordy33 + 305;
       cordy4 = cordy4 + 305;
     }
 
       selected_device.send("^XA\
       ^FX Top section with company logo, name and address.\
       ^CF0,150\
       ^FO50,20^FD" + dataToWrite.number + "^FS\
       ^FO585,187^BY4,2.0,60^BQ,2,5^FDQA,"+dataToWrite.number+"^FS\
       ^CF0,45\
       ^FO45,170^FD"+dataToWrite.client_customer+"^FS\
       ^CF0,40\
       ^FO50,240^GB750,1,3^FS\
       ^CF0,45\
       ^FO50,255^FD" + eliminarDiacriticos(dataToWrite.contents[0].container.text) + "^FS\
       ^FO50,295^FD" + eliminarDiacriticos(dataToWrite.contents[0].condition) + "^FS\
       ^FO50,335^FD" + eliminarDiacriticos(dataToWrite.contents[0].product_type_name) + "^FS\
       ^CF0,40\
       ^FO50,380^GB750,1,3^FS\
       ^FO50,420^GB750,1,3^FS\
       ^CF0,35\
       ^FO50,388^FDDETALLE^FS\
       ^FX Seccion de detalle segun SAG\
       " + detalles + "\
       ^CF0,80\
       ^FO50," +cordy1+ "^FDENVASES:" +total_cantidad+"^FS\
       ^FO50," +(parseInt(cordy1)+parseInt(80))+ "^FDUN:" +dataToWrite.total_net_kilograms+"^FS\
       ^FX  section with barcode.\
       ^BY2,2,100\
       ^FX Cantidada de etiquetas.\
       ^PQ" + numbrePrint + "\
       ^XZ", successCallback, errorCallback);
 
   }

  

};


function errorCallback(errorMessage) {

  miniToastr.info("Problemas al realizar la operación", "");

}


export function successCallback(successMessage) {

  miniToastr.info("Impresión realizada con éxito.", "");

}


function formato(texto) {
  return texto.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1');
}

function eliminarDiacriticos(texto) {

  if(texto===null)
  {
    return "Sin informacion";
  }else{
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
  
}


function eliminarDiacriticos2(texto) {

  if(texto===null)
  {
    return "Sin informacion";
  }else{
    let textAux =  texto.split("~").join("-");
    return textAux.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
  
}
